import React, { useState } from 'react';
import SocialMedia from './SocialMedia';
import Locale from '../locales/en/introduction';

const Introduction = () => {
  // Sets index to allow onClick to change content
  const [carouselIndex, setCarouselIndex] = useState(0);
  const [carouselToggle, setCarouselToggle] = useState(false);

  // Changes content shown in carousel
  const handleClick = (e) => {
    setCarouselIndex(parseInt(e.target.value, 10));
    setCarouselToggle(!carouselToggle);
  };

  const mobileContent = Locale.introductionContent.map((content) => (
    <p>{content}</p>
  ));

  const buttons = Locale.introductionContent.map((button, index) => (
    <button
      type="button"
      className={carouselIndex === index ? 'active' : null}
      aria-label="carousel"
      key={button}
      value={index}
      onClick={handleClick}
    />
  ));

  return (
    <div id="introduction">
      <div className="house-image" />
      <div className="carousel">
        <SocialMedia />
        <div className="carousel-header">
          <h2>
            {Locale.introductionTitle}
          </h2>
          <div className="carousel-navigation">
            {buttons}
          </div>
        </div>
        <div className="carousel-body">
          <div className={`toggle-${carouselToggle}`}>
            {Locale.introductionContent[carouselIndex]}
          </div>
        </div>
        <div className="carousel-body-mobile">
          {mobileContent}
        </div>
      </div>
    </div>
  );
};

export default Introduction;
